/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsClientControllerGetActiveByTypeV1$Params {
}

export function termsClientControllerGetActiveByTypeV1(http: HttpClient, rootUrl: string, params?: TermsClientControllerGetActiveByTypeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
  const rb = new RequestBuilder(rootUrl, termsClientControllerGetActiveByTypeV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermsDto>;
    })
  );
}

termsClientControllerGetActiveByTypeV1.PATH = '/api/v1/terms/client/{type}';
